import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { responsiveSliderSettings } from "../utilities/ui";

class Person extends Component {
  // toggleViewMore() {
  //   this.setState({ isViewingMore: !this.state.isViewingMore });
  // }

  render() {
    // const { isViewingMore } = this.state;
    const DIMENSION = 245;
    const { person } = this.props;

    const personContent = (
      <React.Fragment>
        <h4 style={{ margin: 0, fontSize: "1.2em" }}>{person.name}</h4>
        <div>
          <em style={{ fontSize: ".8rem" }}>{person.title}</em>
        </div>
      </React.Fragment>
    );

    let content = personContent;

    if (person.link) {
      content = (
        <a className="magenta-hover" href={person.link} target="_blank" rel="noopener">
          {personContent}
        </a>
      );
    }

    return (
      <div
        style={{
          marginBottom: "1rem",
        }}
      >
        <div style={{}}>
          {person.photo && (
            <img src={`${person.photo}?w=${DIMENSION}&h=${DIMENSION}&fit=fill`} />
          )}
        </div>
        <div
          style={{
            textAlign: "center",
          }}
        >
          {content}
        </div>
      </div>
    );
  }
}
// needed schema edits
// People - id, name, peopleGroupId, title, shortDesc, longDesc
// PeopleGroup - id, name
class PeopleViewer extends Component {
  constructor(props) {
    super(props);

    this.state = { selectedCategoryIndex: 0 };
  }

  selectCategory(val) {
    let newVal = null;
    if (this.state.selectedCategoryIndex !== val) {
      newVal = val;
    }
    this.setState({ selectedCategoryIndex: newVal });
  }

  render() {
    const { peopleCategories } = this.props;

    const culturalAdvisors = peopleCategories.find(
      (cat) => cat.name.toLowerCase() === "cultural advisors",
    );

    console.log(culturalAdvisors, peopleCategories);
    return (
      <div>
        {culturalAdvisors && culturalAdvisors.people.length > 0 && (
          <Slider
            autoplay={false}
            autoplaySpeed={2500}
            speed={500}
            slidesToShow={6}
            slidesToScroll={2}
            infinite={true}
            dots={true}
            responsive={responsiveSliderSettings}
          >
            {culturalAdvisors.people.map((person) => {
              return (
                <div style={{ display: "inline-block" }}>
                  <Person person={person} />
                </div>
              );
            })}
          </Slider>
        )}
      </div>
    );
  }
}

export default PeopleViewer;



// WEBPACK FOOTER //
// ./src/components/PeopleViewer.js